export const getTranslationKeyForZero = shortVersion =>
    shortVersion
        ? 'shipping-time-same-day-short'

    : 'shipping-time-same-day';
